import { render, staticRenderFns } from "./siteDetails.vue?vue&type=template&id=05fda703&scoped=true"
import script from "./siteDetails.vue?vue&type=script&lang=js"
export * from "./siteDetails.vue?vue&type=script&lang=js"
import style0 from "./siteDetails.vue?vue&type=style&index=0&id=05fda703&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fda703",
  null
  
)

export default component.exports